import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface IconProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * Accessible name. Omit when the icon is decorative and adjacent text already
   * carries the meaning — 07-11: an icon is never the sole carrier of meaning.
   */
  label?: string;
  disabled?: boolean;
  children: ReactNode;
}

/** PRM-16 Icon. `aria-hidden` when decorative; named when it is the only content. */
export function Icon({ label, disabled, className, children, ...props }: IconProps) {
  return (
    <span
      data-primitive="PRM-16"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn(
        'inline-flex size-icon shrink-0 items-center justify-center',
        disabled && 'text-disabled',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
